import { render } from "./PhonePrefixSelect.vue?vue&type=template&id=ecb8a704&scoped=true&ts=true"
import script from "./PhonePrefixSelect.vue?vue&type=script&lang=ts"
export * from "./PhonePrefixSelect.vue?vue&type=script&lang=ts"

import "./PhonePrefixSelect.vue?vue&type=style&index=0&id=ecb8a704&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb8a704"]])

export default __exports__